var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.136 1 1 4.136 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1ZM8.7 12.9H7.3V11.5H8.7V12.9ZM10.149 7.475L9.519 8.119C9.015 8.63 8.7 9.05 8.7 10.1H7.3V9.75C7.3 8.98 7.615 8.28 8.119 7.769L8.987 6.887C9.246 6.635 9.4 6.285 9.4 5.9C9.4 5.13 8.77 4.5 8 4.5C7.23 4.5 6.6 5.13 6.6 5.9H5.2C5.2 4.353 6.453 3.1 8 3.1C9.547 3.1 10.8 4.353 10.8 5.9C10.8 6.516 10.548 7.076 10.149 7.475Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleFilled);
export default __webpack_public_path__ + "static/media/QuestionCircleFilled.37fad897d9b96850d6d2c73677d7912d.svg";
export { ForwardRef as ReactComponent };